import { gql } from "@apollo/client";
export const validateRoutesForAgreementQuery = gql`
  query RoutesValidation(
    $headAgreementId: ID!
    $custNo: Int!
    $multiLegAgreements: [String!]
    $routeAgreements: [String!]
  ) {
    validateRoutesForAgreement(
      headAgreementId: $headAgreementId
      custNo: $custNo
      multiLegAgreements: $multiLegAgreements
      routeAgreements: $routeAgreements
    ) {
      validationResult {
        validationErrors {
          path
          errorMessage
          severityLevel
          statusCode
        }
        resourceId
        statusCode
      }
    }
  }
`;
